/* eslint-disable */
//
// This file is auto-generated by build.ts
// Do not modify manually, please do: bun run wasm
//

/**
 * Mapping from original function names to minified WASM export names.
 * Using const enum so values are inlined at compile time.
 */
export const enum PdfiumExports {
  __cxa_throw = "h",
  __indirect_function_table = "S",
  __syscall_fcntl64 = "f",
  __syscall_fstat64 = "F",
  __syscall_ftruncate64 = "z",
  __syscall_getdents64 = "t",
  __syscall_ioctl = "G",
  __syscall_lstat64 = "D",
  __syscall_newfstatat = "C",
  __syscall_openat = "g",
  __syscall_rmdir = "r",
  __syscall_stat64 = "E",
  __syscall_unlinkat = "s",
  __wasm_call_ctors = "J",
  _abort_js = "i",
  _emscripten_runtime_keepalive_clear = "n",
  _emscripten_stack_restore = "ni",
  _emscripten_throw_longjmp = "p",
  _emscripten_timeout = "li",
  _gmtime_js = "u",
  _localtime_js = "v",
  _setitimer_js = "o",
  _tzset_js = "j",
  emscripten_builtin_memalign = "ki",
  emscripten_date_now = "b",
  emscripten_resize_heap = "q",
  emscripten_stack_get_current = "oi",
  environ_get = "x",
  environ_sizes_get = "y",
  fd_close = "a",
  fd_read = "e",
  fd_seek = "w",
  fd_sync = "B",
  fd_write = "d",
  FORM_CanRedo = "Ee",
  FORM_CanUndo = "De",
  FORM_DoDocumentAAction = "Se",
  FORM_DoDocumentJSAction = "Qe",
  FORM_DoDocumentOpenAction = "Re",
  FORM_DoPageAAction = "Te",
  FORM_ForceToKillFocus = "He",
  FORM_GetFocusedAnnot = "Ie",
  FORM_GetFocusedText = "ye",
  FORM_GetSelectedText = "ze",
  FORM_IsIndexSelected = "Ve",
  FORM_OnAfterLoadPage = "Oe",
  FORM_OnBeforeClosePage = "Pe",
  FORM_OnChar = "xe",
  FORM_OnFocus = "pe",
  FORM_OnKeyDown = "ve",
  FORM_OnKeyUp = "we",
  FORM_OnLButtonDoubleClick = "se",
  FORM_OnLButtonDown = "qe",
  FORM_OnLButtonUp = "re",
  FORM_OnMouseMove = "ne",
  FORM_OnMouseWheel = "oe",
  FORM_OnRButtonDown = "te",
  FORM_OnRButtonUp = "ue",
  FORM_Redo = "Ge",
  FORM_ReplaceAndKeepSelection = "Ae",
  FORM_ReplaceSelection = "Be",
  FORM_SelectAllText = "Ce",
  FORM_SetFocusedAnnot = "Je",
  FORM_SetIndexSelected = "Ue",
  FORM_Undo = "Fe",
  FPDF_AddInstalledFont = "ag",
  FPDF_CloseDocument = "P",
  FPDF_ClosePage = "Jh",
  FPDF_CloseXObject = "df",
  FPDF_CopyViewerPreferences = "ff",
  FPDF_CountNamedDests = "di",
  FPDF_CreateClipPath = "ih",
  FPDF_CreateNewDocument = "O",
  FPDF_DestroyClipPath = "jh",
  FPDF_DestroyLibrary = "nh",
  FPDF_DeviceToPage = "Lh",
  FPDF_DocumentHasValidCrossReferenceTable = "wh",
  FPDF_FFLDraw = "Ke",
  FPDF_FreeDefaultSystemFontInfo = "gg",
  FPDF_GetDefaultSystemFontInfo = "fg",
  FPDF_GetDefaultTTFMap = "cg",
  FPDF_GetDefaultTTFMapCount = "dg",
  FPDF_GetDefaultTTFMapEntry = "eg",
  FPDF_GetDocPermissions = "xh",
  FPDF_GetDocUserPermissions = "yh",
  FPDF_GetFileIdentifier = "Zb",
  FPDF_GetFileVersion = "vh",
  FPDF_GetFormType = "qh",
  FPDF_GetLastError = "Kh",
  FPDF_GetMetaText = "_b",
  FPDF_GetNamedDest = "fi",
  FPDF_GetNamedDestByName = "ei",
  FPDF_GetPageAAction = "Yb",
  FPDF_GetPageBoundingBox = "Gh",
  FPDF_GetPageCount = "Ah",
  FPDF_GetPageHeight = "Fh",
  FPDF_GetPageHeightF = "Eh",
  FPDF_GetPageLabel = "$b",
  FPDF_GetPageSizeByIndex = "Xh",
  FPDF_GetPageSizeByIndexF = "Wh",
  FPDF_GetPageWidth = "Dh",
  FPDF_GetPageWidthF = "Ch",
  FPDF_GetSecurityHandlerRevision = "zh",
  FPDF_GetSignatureCount = "pf",
  FPDF_GetSignatureObject = "qf",
  FPDF_GetTrailerEnds = "ji",
  FPDF_GetXFAPacketContent = "ii",
  FPDF_GetXFAPacketCount = "gi",
  FPDF_GetXFAPacketName = "hi",
  FPDF_ImportNPagesToOne = "bf",
  FPDF_ImportPages = "af",
  FPDF_ImportPagesByIndex = "$e",
  FPDF_InitLibrary = "lh",
  FPDF_InitLibraryWithConfig = "mh",
  FPDF_LoadCustomDocument = "uh",
  FPDF_LoadDocument = "ph",
  FPDF_LoadMemDocument = "sh",
  FPDF_LoadMemDocument64 = "th",
  FPDF_LoadPage = "Bh",
  FPDF_LoadXFA = "rh",
  FPDF_MovePages = "pc",
  FPDF_NewFormObjectFromXObject = "ef",
  FPDF_NewXObjectFromPage = "cf",
  FPDF_PageToDevice = "Mh",
  FPDF_RemoveFormFieldHighlight = "Ne",
  FPDF_RenderPage_Close = "kf",
  FPDF_RenderPage_Continue = "jf",
  FPDF_RenderPageBitmap = "Hh",
  FPDF_RenderPageBitmap_Start = "hf",
  FPDF_RenderPageBitmapWithColorScheme_Start = "gf",
  FPDF_RenderPageBitmapWithMatrix = "Ih",
  FPDF_SaveAsCopy = "lf",
  FPDF_SaveWithVersion = "mf",
  FPDF_SetFormFieldHighlightAlpha = "Me",
  FPDF_SetFormFieldHighlightColor = "Le",
  FPDF_SetSandBoxPolicy = "oh",
  FPDF_SetSystemFontInfo = "bg",
  FPDF_StructElement_Attr_CountChildren = "Yf",
  FPDF_StructElement_Attr_GetBlobValue = "Xf",
  FPDF_StructElement_Attr_GetBooleanValue = "Uf",
  FPDF_StructElement_Attr_GetChildAtIndex = "Zf",
  FPDF_StructElement_Attr_GetCount = "Qf",
  FPDF_StructElement_Attr_GetName = "Rf",
  FPDF_StructElement_Attr_GetNumberValue = "Vf",
  FPDF_StructElement_Attr_GetStringValue = "Wf",
  FPDF_StructElement_Attr_GetType = "Tf",
  FPDF_StructElement_Attr_GetValue = "Sf",
  FPDF_StructElement_CountChildren = "Mf",
  FPDF_StructElement_GetActualText = "Cf",
  FPDF_StructElement_GetAltText = "Bf",
  FPDF_StructElement_GetAttributeAtIndex = "Gf",
  FPDF_StructElement_GetAttributeCount = "Ff",
  FPDF_StructElement_GetChildAtIndex = "Nf",
  FPDF_StructElement_GetChildMarkedContentID = "Of",
  FPDF_StructElement_GetID = "Df",
  FPDF_StructElement_GetLang = "Ef",
  FPDF_StructElement_GetMarkedContentID = "If",
  FPDF_StructElement_GetMarkedContentIdAtIndex = "$f",
  FPDF_StructElement_GetMarkedContentIdCount = "_f",
  FPDF_StructElement_GetObjType = "Kf",
  FPDF_StructElement_GetParent = "Pf",
  FPDF_StructElement_GetStringAttribute = "Hf",
  FPDF_StructElement_GetTitle = "Lf",
  FPDF_StructElement_GetType = "Jf",
  FPDF_StructTree_Close = "yf",
  FPDF_StructTree_CountChildren = "zf",
  FPDF_StructTree_GetChildAtIndex = "Af",
  FPDF_StructTree_GetForPage = "xf",
  FPDF_VIEWERREF_GetDuplex = "bi",
  FPDF_VIEWERREF_GetName = "ci",
  FPDF_VIEWERREF_GetNumCopies = "Zh",
  FPDF_VIEWERREF_GetPrintPageRange = "_h",
  FPDF_VIEWERREF_GetPrintPageRangeCount = "$h",
  FPDF_VIEWERREF_GetPrintPageRangeElement = "ai",
  FPDF_VIEWERREF_GetPrintScaling = "Yh",
  FPDFAction_GetDest = "Jb",
  FPDFAction_GetFilePath = "Kb",
  FPDFAction_GetType = "Ib",
  FPDFAction_GetURIPath = "Lb",
  FPDFAnnot_AddFileAttachment = "eb",
  FPDFAnnot_AddInkStroke = "da",
  FPDFAnnot_AppendAttachmentPoints = "na",
  FPDFAnnot_AppendObject = "fa",
  FPDFAnnot_CountAttachmentPoints = "oa",
  FPDFAnnot_GetAP = "Ea",
  FPDFAnnot_GetAttachmentPoints = "pa",
  FPDFAnnot_GetBorder = "xa",
  FPDFAnnot_GetColor = "ka",
  FPDFAnnot_GetFileAttachment = "db",
  FPDFAnnot_GetFlags = "Ga",
  FPDFAnnot_GetFocusableSubtypes = "Za",
  FPDFAnnot_GetFocusableSubtypesCount = "Ya",
  FPDFAnnot_GetFontColor = "Va",
  FPDFAnnot_GetFontSize = "Ta",
  FPDFAnnot_GetFormAdditionalActionJavaScript = "Na",
  FPDFAnnot_GetFormControlCount = "$a",
  FPDFAnnot_GetFormControlIndex = "ab",
  FPDFAnnot_GetFormFieldAlternateName = "Oa",
  FPDFAnnot_GetFormFieldAtPoint = "Ka",
  FPDFAnnot_GetFormFieldExportValue = "bb",
  FPDFAnnot_GetFormFieldFlags = "Ia",
  FPDFAnnot_GetFormFieldName = "La",
  FPDFAnnot_GetFormFieldType = "Ma",
  FPDFAnnot_GetFormFieldValue = "Pa",
  FPDFAnnot_GetInkListCount = "ta",
  FPDFAnnot_GetInkListPath = "ua",
  FPDFAnnot_GetLine = "va",
  FPDFAnnot_GetLink = "_a",
  FPDFAnnot_GetLinkedAnnot = "Fa",
  FPDFAnnot_GetNumberValue = "Ca",
  FPDFAnnot_GetObject = "ha",
  FPDFAnnot_GetObjectCount = "ga",
  FPDFAnnot_GetOptionCount = "Qa",
  FPDFAnnot_GetOptionLabel = "Ra",
  FPDFAnnot_GetRect = "ra",
  FPDFAnnot_GetStringValue = "Ba",
  FPDFAnnot_GetSubtype = "aa",
  FPDFAnnot_GetValueType = "za",
  FPDFAnnot_GetVertices = "sa",
  FPDFAnnot_HasAttachmentPoints = "la",
  FPDFAnnot_HasKey = "ya",
  FPDFAnnot_IsChecked = "Wa",
  FPDFAnnot_IsObjectSupportedSubtype = "ba",
  FPDFAnnot_IsOptionSelected = "Sa",
  FPDFAnnot_IsSupportedSubtype = "V",
  FPDFAnnot_RemoveInkList = "ea",
  FPDFAnnot_RemoveObject = "ia",
  FPDFAnnot_SetAP = "Da",
  FPDFAnnot_SetAttachmentPoints = "ma",
  FPDFAnnot_SetBorder = "wa",
  FPDFAnnot_SetColor = "ja",
  FPDFAnnot_SetFlags = "Ha",
  FPDFAnnot_SetFocusableSubtypes = "Xa",
  FPDFAnnot_SetFontColor = "Ua",
  FPDFAnnot_SetFormFieldFlags = "Ja",
  FPDFAnnot_SetRect = "qa",
  FPDFAnnot_SetStringValue = "Aa",
  FPDFAnnot_SetURI = "cb",
  FPDFAnnot_UpdateObject = "ca",
  FPDFAttachment_GetFile = "pb",
  FPDFAttachment_GetName = "jb",
  FPDFAttachment_GetStringValue = "nb",
  FPDFAttachment_GetSubtype = "qb",
  FPDFAttachment_GetValueType = "lb",
  FPDFAttachment_HasKey = "kb",
  FPDFAttachment_SetFile = "ob",
  FPDFAttachment_SetStringValue = "mb",
  FPDFAvail_Create = "tb",
  FPDFAvail_Destroy = "ub",
  FPDFAvail_GetDocument = "wb",
  FPDFAvail_GetFirstPageNum = "xb",
  FPDFAvail_IsDocAvail = "vb",
  FPDFAvail_IsFormAvail = "zb",
  FPDFAvail_IsLinearized = "Ab",
  FPDFAvail_IsPageAvail = "yb",
  FPDFBitmap_Create = "Nh",
  FPDFBitmap_CreateEx = "Oh",
  FPDFBitmap_Destroy = "Vh",
  FPDFBitmap_FillRect = "Qh",
  FPDFBitmap_GetBuffer = "Rh",
  FPDFBitmap_GetFormat = "Ph",
  FPDFBitmap_GetHeight = "Th",
  FPDFBitmap_GetStride = "Uh",
  FPDFBitmap_GetWidth = "Sh",
  FPDFBookmark_Find = "Fb",
  FPDFBookmark_GetAction = "Hb",
  FPDFBookmark_GetCount = "Eb",
  FPDFBookmark_GetDest = "Gb",
  FPDFBookmark_GetFirstChild = "Bb",
  FPDFBookmark_GetNextSibling = "Cb",
  FPDFBookmark_GetTitle = "Db",
  FPDFCatalog_IsTagged = "rb",
  FPDFCatalog_SetLanguage = "sb",
  FPDFClipPath_CountPaths = "fh",
  FPDFClipPath_CountPathSegments = "gh",
  FPDFClipPath_GetPathSegment = "hh",
  FPDFDest_GetDestPageIndex = "Mb",
  FPDFDest_GetLocationInPage = "Ob",
  FPDFDest_GetView = "Nb",
  FPDFDoc_AddAttachment = "gb",
  FPDFDoc_CloseJavaScriptAction = "Ye",
  FPDFDoc_DeleteAttachment = "ib",
  FPDFDOC_ExitFormFillEnvironment = "me",
  FPDFDoc_GetAttachment = "hb",
  FPDFDoc_GetAttachmentCount = "fb",
  FPDFDoc_GetJavaScriptAction = "Xe",
  FPDFDoc_GetJavaScriptActionCount = "We",
  FPDFDoc_GetPageMode = "he",
  FPDFDOC_InitFormFillEnvironment = "le",
  FPDFFont_Close = "Rd",
  FPDFFont_GetAscent = "be",
  FPDFFont_GetBaseFontName = "Wd",
  FPDFFont_GetDescent = "ce",
  FPDFFont_GetFamilyName = "Xd",
  FPDFFont_GetFlags = "_d",
  FPDFFont_GetFontData = "Yd",
  FPDFFont_GetGlyphPath = "ee",
  FPDFFont_GetGlyphWidth = "de",
  FPDFFont_GetIsEmbedded = "Zd",
  FPDFFont_GetItalicAngle = "ae",
  FPDFFont_GetWeight = "$d",
  FPDFFormObj_CountObjects = "sd",
  FPDFFormObj_GetObject = "td",
  FPDFFormObj_RemoveObject = "ud",
  FPDFGlyphPath_CountGlyphSegments = "fe",
  FPDFGlyphPath_GetGlyphPathSegment = "ge",
  FPDFImageObj_GetBitmap = "fc",
  FPDFImageObj_GetIccProfileDataDecoded = "nc",
  FPDFImageObj_GetImageDataDecoded = "hc",
  FPDFImageObj_GetImageDataRaw = "ic",
  FPDFImageObj_GetImageFilter = "kc",
  FPDFImageObj_GetImageFilterCount = "jc",
  FPDFImageObj_GetImageMetadata = "lc",
  FPDFImageObj_GetImagePixelSize = "mc",
  FPDFImageObj_GetRenderedBitmap = "gc",
  FPDFImageObj_LoadJpegFile = "bc",
  FPDFImageObj_LoadJpegFileInline = "cc",
  FPDFImageObj_SetBitmap = "ec",
  FPDFImageObj_SetMatrix = "dc",
  FPDFJavaScriptAction_GetName = "Ze",
  FPDFJavaScriptAction_GetScript = "_e",
  FPDFLink_CloseWebLinks = "Qg",
  FPDFLink_CountQuadPoints = "Wb",
  FPDFLink_CountRects = "Ng",
  FPDFLink_CountWebLinks = "Lg",
  FPDFLink_Enumerate = "Tb",
  FPDFLink_GetAction = "Sb",
  FPDFLink_GetAnnot = "Ub",
  FPDFLink_GetAnnotRect = "Vb",
  FPDFLink_GetDest = "Rb",
  FPDFLink_GetLinkAtPoint = "Pb",
  FPDFLink_GetLinkZOrderAtPoint = "Qb",
  FPDFLink_GetQuadPoints = "Xb",
  FPDFLink_GetRect = "Og",
  FPDFLink_GetTextRange = "Pg",
  FPDFLink_GetURL = "Mg",
  FPDFLink_LoadWebLinks = "Kg",
  FPDFPage_CloseAnnot = "_",
  FPDFPage_CountObjects = "vc",
  FPDFPage_CreateAnnot = "W",
  FPDFPage_Delete = "oc",
  FPDFPage_Flatten = "ie",
  FPDFPage_FormFieldZOrderAtPoint = "ke",
  FPDFPage_GenerateContent = "Vc",
  FPDFPage_GetAnnot = "Y",
  FPDFPage_GetAnnotCount = "X",
  FPDFPage_GetAnnotIndex = "Z",
  FPDFPage_GetArtBox = "bh",
  FPDFPage_GetBleedBox = "$g",
  FPDFPage_GetCropBox = "_g",
  FPDFPage_GetDecodedThumbnailData = "Rg",
  FPDFPage_GetMediaBox = "Zg",
  FPDFPage_GetObject = "wc",
  FPDFPage_GetRawThumbnailData = "Sg",
  FPDFPage_GetRotation = "rc",
  FPDFPage_GetThumbnailAsBitmap = "Tg",
  FPDFPage_GetTrimBox = "ah",
  FPDFPage_HasFormFieldAtPoint = "je",
  FPDFPage_HasTransparency = "xc",
  FPDFPage_InsertClipPath = "kh",
  FPDFPage_InsertObject = "sc",
  FPDFPage_InsertObjectAtIndex = "tc",
  FPDFPage_New = "qc",
  FPDFPage_RemoveAnnot = "$",
  FPDFPage_RemoveObject = "uc",
  FPDFPage_SetArtBox = "Yg",
  FPDFPage_SetBleedBox = "Wg",
  FPDFPage_SetCropBox = "Vg",
  FPDFPage_SetMediaBox = "Ug",
  FPDFPage_SetRotation = "ad",
  FPDFPage_SetTrimBox = "Xg",
  FPDFPage_TransformAnnots = "$c",
  FPDFPage_TransFormWithClip = "ch",
  FPDFPageObj_AddMark = "Cc",
  FPDFPageObj_CountMarks = "Ac",
  FPDFPageObj_CreateNewPath = "vd",
  FPDFPageObj_CreateNewRect = "wd",
  FPDFPageObj_CreateTextObj = "Sd",
  FPDFPageObj_Destroy = "yc",
  FPDFPageObj_GetBounds = "dd",
  FPDFPageObj_GetClipPath = "eh",
  FPDFPageObj_GetDashArray = "qd",
  FPDFPageObj_GetDashCount = "pd",
  FPDFPageObj_GetDashPhase = "nd",
  FPDFPageObj_GetFillColor = "cd",
  FPDFPageObj_GetIsActive = "Tc",
  FPDFPageObj_GetLineCap = "ld",
  FPDFPageObj_GetLineJoin = "jd",
  FPDFPageObj_GetMark = "Bc",
  FPDFPageObj_GetMarkedContentID = "zc",
  FPDFPageObj_GetMatrix = "Yc",
  FPDFPageObj_GetRotatedBounds = "ed",
  FPDFPageObj_GetStrokeColor = "gd",
  FPDFPageObj_GetStrokeWidth = "id",
  FPDFPageObj_GetType = "Sc",
  FPDFPageObj_HasTransparency = "Mc",
  FPDFPageObj_NewImageObj = "ac",
  FPDFPageObj_NewTextObj = "Id",
  FPDFPageObj_RemoveMark = "Dc",
  FPDFPageObj_SetBlendMode = "_c",
  FPDFPageObj_SetDashArray = "rd",
  FPDFPageObj_SetDashPhase = "od",
  FPDFPageObj_SetFillColor = "bd",
  FPDFPageObj_SetIsActive = "Uc",
  FPDFPageObj_SetLineCap = "md",
  FPDFPageObj_SetLineJoin = "kd",
  FPDFPageObj_SetMatrix = "Zc",
  FPDFPageObj_SetStrokeColor = "fd",
  FPDFPageObj_SetStrokeWidth = "hd",
  FPDFPageObj_Transform = "Wc",
  FPDFPageObj_TransformClipPath = "dh",
  FPDFPageObj_TransformF = "Xc",
  FPDFPageObjMark_CountParams = "Fc",
  FPDFPageObjMark_GetName = "Ec",
  FPDFPageObjMark_GetParamBlobValue = "Lc",
  FPDFPageObjMark_GetParamFloatValue = "Jc",
  FPDFPageObjMark_GetParamIntValue = "Ic",
  FPDFPageObjMark_GetParamKey = "Gc",
  FPDFPageObjMark_GetParamStringValue = "Kc",
  FPDFPageObjMark_GetParamValueType = "Hc",
  FPDFPageObjMark_RemoveParam = "Rc",
  FPDFPageObjMark_SetBlobParam = "Qc",
  FPDFPageObjMark_SetFloatParam = "Oc",
  FPDFPageObjMark_SetIntParam = "Nc",
  FPDFPageObjMark_SetStringParam = "Pc",
  FPDFPath_BezierTo = "Bd",
  FPDFPath_Close = "Cd",
  FPDFPath_CountSegments = "xd",
  FPDFPath_GetDrawMode = "Ed",
  FPDFPath_GetPathSegment = "yd",
  FPDFPath_LineTo = "Ad",
  FPDFPath_MoveTo = "zd",
  FPDFPath_SetDrawMode = "Dd",
  FPDFPathSegment_GetClose = "Hd",
  FPDFPathSegment_GetPoint = "Fd",
  FPDFPathSegment_GetType = "Gd",
  FPDFSignatureObj_GetByteRange = "sf",
  FPDFSignatureObj_GetContents = "rf",
  FPDFSignatureObj_GetDocMDPPermission = "wf",
  FPDFSignatureObj_GetReason = "uf",
  FPDFSignatureObj_GetSubFilter = "tf",
  FPDFSignatureObj_GetTime = "vf",
  FPDFText_ClosePage = "ig",
  FPDFText_CountChars = "jg",
  FPDFText_CountRects = "Bg",
  FPDFText_FindClose = "Jg",
  FPDFText_FindNext = "Fg",
  FPDFText_FindPrev = "Gg",
  FPDFText_FindStart = "Eg",
  FPDFText_GetBoundedText = "Dg",
  FPDFText_GetCharAngle = "ug",
  FPDFText_GetCharBox = "vg",
  FPDFText_GetCharIndexAtPos = "zg",
  FPDFText_GetCharIndexFromTextIndex = "nf",
  FPDFText_GetCharOrigin = "yg",
  FPDFText_GetFillColor = "sg",
  FPDFText_GetFontInfo = "qg",
  FPDFText_GetFontSize = "pg",
  FPDFText_GetFontWeight = "rg",
  FPDFText_GetLooseCharBox = "wg",
  FPDFText_GetMatrix = "xg",
  FPDFText_GetRect = "Cg",
  FPDFText_GetSchCount = "Ig",
  FPDFText_GetSchResultIndex = "Hg",
  FPDFText_GetStrokeColor = "tg",
  FPDFText_GetText = "Ag",
  FPDFText_GetTextIndexFromCharIndex = "of",
  FPDFText_GetTextObject = "lg",
  FPDFText_GetUnicode = "kg",
  FPDFText_HasUnicodeMapError = "og",
  FPDFText_IsGenerated = "mg",
  FPDFText_IsHyphen = "ng",
  FPDFText_LoadCidType2Font = "Nd",
  FPDFText_LoadFont = "Ld",
  FPDFText_LoadPage = "hg",
  FPDFText_LoadStandardFont = "Md",
  FPDFText_SetCharcodes = "Kd",
  FPDFText_SetText = "Jd",
  FPDFTextObj_GetFont = "Vd",
  FPDFTextObj_GetFontSize = "Od",
  FPDFTextObj_GetRenderedBitmap = "Qd",
  FPDFTextObj_GetText = "Pd",
  FPDFTextObj_GetTextRenderMode = "Td",
  FPDFTextObj_SetTextRenderMode = "Ud",
  free = "U",
  invoke_ii = "A",
  invoke_iii = "c",
  invoke_iiii = "l",
  invoke_iiiii = "k",
  invoke_viii = "H",
  malloc = "T",
  memory = "I",
  PDFKING_CopyTransparencyGroup = "R",
  PDFKING_ExportPageObjects = "N",
  PDFKING_HelloWorld = "K",
  PDFKING_PageObj_SetClipRect = "Q",
  PDFKING_PageObj_SetFillColorCMYK = "L",
  PDFKING_PageObj_SetStrokeColorCMYK = "M",
  proc_exit = "m",
  setThrew = "mi",
}

/** Minified import module name */
export const IMPORT_MODULE = "a" as const
